// extracted by mini-css-extract-plugin
module.exports = {"container":"container--uVuto","detail":"detail--HMf96"};